import {Component, ViewEncapsulation} from '@angular/core';
import {NavigateService} from 'ngx-satoris';
import {CartService} from '../../../shared/services/cart.service';

@Component({
  selector: 'app-document-embassy',
  templateUrl: './passport-embassy.component.html',
  styleUrls: ['./passport-embassy.component.scss'],
  encapsulation: ViewEncapsulation.None
})
export class PassportEmbassyComponent {

  constructor(public nav: NavigateService, public cart: CartService) {}

  onBack() {
    this.cart.removeOneElementOLD('document_type');
    this.nav.to('dashboard');
  }
}
